import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'kt-error-msg-component',
  templateUrl: './error-msg-component.component.html',
  styleUrls: ['./error-msg-component.component.css']
})
export class ErrorMsgComponentComponent implements OnInit {
  public isAlertVisible: boolean = true;
  public alertClass: string;
  public alertIcon: string;
  @Input() alertMsgValue: string;
  @Input() alertType:string;
  constructor() { }

  ngOnInit() {
    this.alertBoxMsg(this.alertMsgValue,this.alertType)
  }

  private alertBoxMsg(message, alertType?) {
    if (alertType == 'success') {
      this.alertClass = 'alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-20';
      this.alertIcon = 'fa fa-check-circle'
    } else if (alertType == 'warning') {
      this.alertClass = 'alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-20';
      this.alertIcon = 'fas fa-exclamation-circle'
    } else if (alertType == 'info') {
      this.alertClass = 'alert alert-solid-info alert-bold fade show kt-margin-t-20 kt-margin-b-20';
      this.alertIcon = 'fas fa-lightbulb'
    }
     else if(alertType == 'error') {
      this.alertClass = 'alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-20';
      this.alertIcon = 'fa fa-exclamation-triangle'
    }
    this.alertMsgValue = message;
  }

}
